// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/servicebg1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutoBodyRepair_container__3hcCL {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 78px;
}
@media (max-width: 700px) {
  .AutoBodyRepair_container__3hcCL {
    margin-top: 30px;
  }
}
.AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: auto;
  background: rgba(217, 217, 217, 0.06);
  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);
  border-radius: 26px;
  padding: 20px;
}
.AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw img {
  width: 45%;
  border-color: #EDEDED;
  border-width: 2px;
  border-radius: 0px 0px 0px 98px;
  border-style: solid;
}
@media (max-width: 1100px) {
  .AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw img {
    display: none;
  }
}
.AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div {
  width: 50%;
}
@media (max-width: 1100px) {
  .AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div {
    width: 100%;
  }
}
.AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div h2, .AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div h3 {
  color: #EDEDED;
  font-family: hemi_head;
}
.AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div p {
  color: #EDEDED;
  font-family: Roboto;
  text-align: center;
}
@media (max-width: 700px) {
  .AutoBodyRepair_container__3hcCL .AutoBodyRepair_mainInfo__RJmKw div p {
    text-align: center;
  }
}
.AutoBodyRepair_container__3hcCL h1 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin-bottom: 50px;
}
.AutoBodyRepair_container__3hcCL h1::before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}

.AutoBodyRepair_itemBlock__yUkQa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin: auto;
  background: rgba(217, 217, 217, 0.09);
  box-shadow: 4px 4px 4px rgba(255, 255, 255, 0.25);
  border-radius: 150px 0px;
  color: #ffffff;
  margin-top: 50px;
  margin-bottom: 30px;
  padding: 30px;
  position: relative;
}
@media (max-width: 700px) {
  .AutoBodyRepair_itemBlock__yUkQa {
    border-radius: 100px 0px;
  }
}
.AutoBodyRepair_itemBlock__yUkQa div {
  text-align: center;
  font-family: Roboto;
  width: 80%;
  margin: auto;
}
@media (max-width: 700px) {
  .AutoBodyRepair_itemBlock__yUkQa div {
    width: 98%;
  }
}
.AutoBodyRepair_itemBlock__yUkQa div h2 {
  font-family: hemi_head;
  margin: auto;
  text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);
  font-size: 36px;
}
@media (max-width: 700px) {
  .AutoBodyRepair_itemBlock__yUkQa div h2 {
    font-size: 25px;
  }
}
.AutoBodyRepair_itemBlock__yUkQa div .AutoBodyRepair_text1__a8yYp {
  display: flex;
  width: 100%;
}
.AutoBodyRepair_itemBlock__yUkQa div .AutoBodyRepair_text2__KBI3b {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.AutoBodyRepair_itemBlock__yUkQa div p {
  max-width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/AutoBodyRepair/AutoBodyRepair.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EAEA,gBAAA;AAAF;AACE;EAXF;IAYI,gBAAA;EAEF;AACF;AADA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;AAGF;AAFE;EACE,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AAIJ;AAHI;EANF;IAOI,aAAA;EAMJ;AACF;AAJE;EACE,UAAA;AAMJ;AALI;EAFF;IAGI,WAAA;EAQJ;AACF;AAPI;EACE,cAAA;EACA,sBAAA;AASN;AAPI;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AASN;AARM;EAJF;IAKI,kBAAA;EAWN;AACF;AAPE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AASJ;AAPI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AASN;;AALA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EAEA,YAAA;EACA,qCAAA;EACA,iDAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAOF;AANE;EAfF;IAgBI,wBAAA;EASF;AACF;AAPE;EACE,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AASJ;AARI;EALF;IAMI,UAAA;EAWJ;AACF;AATI;EACE,sBAAA;EACA,YAAA;EACA,yFAAA;EACA,eAAA;AAWN;AAVM;EALF;IAMI,eAAA;EAaN;AACF;AAVI;EACE,aAAA;EACA,WAAA;AAYN;AATI;EACE,aAAA;EACA,WAAA;EACA,yBAAA;AAWN;AAPI;EACE,gBAAA;AASN","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  justify-content: space-between;\n  align-items: center;\n  background-image: url(\"../../Assets/Images/servicebg1.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  //background-position: center;\n  margin-top: 78px;\n  @media (max-width: 700px) {\n    margin-top: 30px;\n  }\n.mainInfo{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 80%;\n  margin: auto;\n  background: rgba(217, 217, 217, 0.06);\n  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);\n  border-radius: 26px;\n  padding: 20px;\n  img{\n    width: 45%;\n    border-color: #EDEDED;\n    border-width: 2px;\n    border-radius: 0px 0px 0px 98px;\n    border-style: solid;\n    @media (max-width: 1100px) {\n      display: none;\n    }\n  }\n  div{\n    width: 50%;\n    @media (max-width: 1100px) {\n      width: 100%;\n    }\n    h2,h3{\n      color: #EDEDED;\n      font-family: hemi_head;\n    }\n    p{\n      color: #EDEDED;\n      font-family: Roboto;\n      text-align: center;\n      @media (max-width: 700px) {\n        text-align: center;\n      }\n    }\n  }\n}\n  h1 {\n    font-family: \"hemi_head\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 40px;\n    text-align: center;\n    letter-spacing: 0.01em;\n    color: #FFFFFF;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 50px;\n\n    &::before {\n      content: \"\";\n      width: 80%;\n      height: 1px;\n      position: absolute;\n      bottom: -10px;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: #ED1C24;\n    }\n  }\n}\n.itemBlock {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 80%;\n  //min-height: 600px;\n  margin: auto;\n  background: rgba(217, 217, 217, 0.09);\n  box-shadow: 4px 4px 4px rgba(255, 255, 255, 0.25);\n  border-radius: 150px 0px;\n  color: #ffffff;\n  margin-top: 50px;\n  margin-bottom: 30px;\n  padding: 30px;\n  position: relative;\n  @media (max-width: 700px) {\n    border-radius: 100px 0px;\n  }\n\n  div {\n    text-align: center;\n    font-family: Roboto;\n    width: 80%;\n    margin: auto;\n    @media (max-width: 700px) {\n      width: 98%;\n    }\n\n    h2 {\n      font-family: hemi_head;\n      margin: auto;\n      text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);\n      font-size: 36px;\n      @media (max-width: 700px) {\n        font-size: 25px;\n      }\n    }\n\n    .text1 {\n      display: flex;\n      width: 100%;\n    }\n\n    .text2 {\n      display: flex;\n      width: 100%;\n      justify-content: flex-end;\n\n    }\n\n    p {\n      max-width: 400px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AutoBodyRepair_container__3hcCL`,
	"mainInfo": `AutoBodyRepair_mainInfo__RJmKw`,
	"itemBlock": `AutoBodyRepair_itemBlock__yUkQa`,
	"text1": `AutoBodyRepair_text1__a8yYp`,
	"text2": `AutoBodyRepair_text2__KBI3b`
};
export default ___CSS_LOADER_EXPORT___;
